import type {Grant} from 'src/openapi/admin/models/Grant';
import type {Pagination} from 'src/openapi/admin/models/Pagination';
import type {PresetItem} from 'src/openapi/admin/models/PresetItem';
import type {PresetRelationItem} from 'src/openapi/admin/models/PresetRelationItem';
import type {Role} from 'src/openapi/admin/models/Role';

export enum EntitlementType {
    RESOURCE = 'RESOURCE',
    ROLE = 'ROLE',
    GRANT = 'GRANT',
    PRESET = 'PRESET',
    NOT_ASSOCIATED = 'NOT_ASSOCIATED',
}

export type NotAssociatedEntitlementsDetails = {
    activeTab: string,
    pagination: Pagination,
    namespace?: string,
};

export type OpenRequest = {
    entitlementType: EntitlementType,
    entitlementId: string,
    presetRelations?: PresetRelationItem[],
    notAssociatedEntitlementsDetails?: NotAssociatedEntitlementsDetails,
};

export type EntitlementsResource = {
    name: string,
    externalId: string,
    level?: string,
};

export type EntitlementGrant = Grant & {
    resources: EntitlementsResource[],
    level?: string,
};

export type EntitlementRole = Role & {
    grants: EntitlementGrant[],
    level?: string,
};

export type EntitlementPreset = PresetItem & {
    roles: EntitlementRole[],
    freeGrants: EntitlementGrant[],
};
